/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Page_Prize_LandInputs */

const en_invite_page_prize_land = /** @type {(inputs: Invite_Page_Prize_LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pineapple Gummies`)
};

const ar_invite_page_prize_land = /** @type {(inputs: Invite_Page_Prize_LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جيلي الأناناس`)
};

const de_invite_page_prize_land = /** @type {(inputs: Invite_Page_Prize_LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ananas-Gummi`)
};

const es_invite_page_prize_land = /** @type {(inputs: Invite_Page_Prize_LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gominola de Piña`)
};

const fr_invite_page_prize_land = /** @type {(inputs: Invite_Page_Prize_LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ananas Gélifié`)
};

const it_invite_page_prize_land = /** @type {(inputs: Invite_Page_Prize_LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ananas Gommoso`)
};

const ja_invite_page_prize_land = /** @type {(inputs: Invite_Page_Prize_LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パイナップルグミ`)
};

const ko_invite_page_prize_land = /** @type {(inputs: Invite_Page_Prize_LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`파인애플 젤리`)
};

const pt_br_invite_page_prize_land = /** @type {(inputs: Invite_Page_Prize_LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jujuba de Abacaxi`)
};

const ru_invite_page_prize_land = /** @type {(inputs: Invite_Page_Prize_LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ананасовая мармеладка`)
};

const th_invite_page_prize_land = /** @type {(inputs: Invite_Page_Prize_LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กัมมี่สับปะรด`)
};

const tr_invite_page_prize_land = /** @type {(inputs: Invite_Page_Prize_LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ananas Jelibonu`)
};

const zh_cn_invite_page_prize_land = /** @type {(inputs: Invite_Page_Prize_LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`凤梨蜜境`)
};

const zh_tw_invite_page_prize_land = /** @type {(inputs: Invite_Page_Prize_LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`鳳梨蜜境`)
};

/**
* | output |
* | --- |
* | "Pineapple Gummies" |
*
* @param {Invite_Page_Prize_LandInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const invite_page_prize_land = /** @type {((inputs?: Invite_Page_Prize_LandInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Page_Prize_LandInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invite_page_prize_land(inputs)
	if (locale === "ar") return ar_invite_page_prize_land(inputs)
	if (locale === "de") return de_invite_page_prize_land(inputs)
	if (locale === "es") return es_invite_page_prize_land(inputs)
	if (locale === "fr") return fr_invite_page_prize_land(inputs)
	if (locale === "it") return it_invite_page_prize_land(inputs)
	if (locale === "ja") return ja_invite_page_prize_land(inputs)
	if (locale === "ko") return ko_invite_page_prize_land(inputs)
	if (locale === "pt_br") return pt_br_invite_page_prize_land(inputs)
	if (locale === "ru") return ru_invite_page_prize_land(inputs)
	if (locale === "th") return th_invite_page_prize_land(inputs)
	if (locale === "tr") return tr_invite_page_prize_land(inputs)
	if (locale === "zh_cn") return zh_cn_invite_page_prize_land(inputs)
	return zh_tw_invite_page_prize_land(inputs)
});